const Reports = () => {
  return (
    <div data-testid="reports-page">
      <h1 style={{ fontSize: '2rem', fontWeight: 700, marginBottom: '2rem' }}>Reports</h1>
      <div className="card">
        <p>Revenue, expenses, employee performance, and inventory reports coming soon...</p>
      </div>
    </div>
  );
};

export default Reports;
